import { HiOutlineExclamation } from 'react-icons/hi';
import styles from './WarningInputMessage.module.scss';

const HelperDesc = ({ message }: { message?: string }) => {
    return (
        <span className={styles.root}>
            <HiOutlineExclamation style={{ fontSize: '14px' }} />
            <span className={styles.desc}>{message}</span>
        </span>
    );
};

export default HelperDesc;
